import React from "react";
import * as Sentry from "@sentry/react";

import { ErrorBoundary } from "widgets/layouts";
import { LazyRemote } from "widgets/lazyremote";
import { useUserStore } from "base/stores";
import { ENVIRONMENT_TYPES } from "base/constants";

import { BaseComponent, PrivateRoute } from "./components/base/index.jsx";
import { SupportChannel } from "./support_channel/index.jsx";

function AppBuilderWrapper() {
  return (
    <ErrorBoundary>
      <BaseComponent baseName="/appbuilder">
        <PrivateRoute path="/" baseRedirect={true}>
          <AppBuilderHome />
        </PrivateRoute>
      </BaseComponent>
    </ErrorBoundary>
  );
}

function AppBuilderHome() {
  const sandbox = useUserStore((state) => state.sandbox);

  const currentEnv =
    sandbox.find((env) => env._id === window?.accountDetails?._id) || {};

  if (currentEnv.Type === ENVIRONMENT_TYPES.DEVELOPMENT) {
    return (
      <React.Fragment>
        <LazyRemote
          name="application"
          module="kfapplication/builder"
          componentName="AppBuilder"
        />
        <SupportChannel />
      </React.Fragment>
    );
  }

  return null;
}

export const AppBuilder = Sentry.withProfiler(AppBuilderWrapper);
